import { Popover } from '@mui/material'
import { useState } from 'react'
import { PRESCRIPTION_BUILDER_VIEW_TYPES } from 'src/consumer/constants'
import { getFirstLetterCapitalizedString } from 'src/consumer/helpers/utilFunctions'
import {
  commonStylesPrescriptionSelect,
  loadOptionsComplaints,
} from '../../PrescriptionMakingPageComponents'
import { ComplaintCreatableSelect } from '../../PrescriptionMakingPageStyles'
import HealthEntityAddPopover from '../common/HealthEntityAddPopover'
import PrescriptionPillViewInputComponent from '../common/PrescriptionPillViewInputComponent'
import PrescriptionTableViewInputComponent from '../common/PrescriptionTableViewInputComponent'
import { handleChangeHealthEntityInputType1, handleKeyDownAndSupportEdit } from '../common/helpers'
import ComplaintsTabularInput from './components/ComplaintsTabularInput'

export default function HealthComplaintsInputComponent({
  clinicId,
  clinicBrandId,
  selectedComplaints,
  setSelectedComplaints,
  recommendedComplaints = [],
  prescriptionViewSettings,
  contextMenuSide,
}) {
  const [addHealthComplaintButtonAnchor, setAddComplaintButtonAnchor] = useState(false)
  const [healthComplaintToCreate, setHealthComplaintToCreate] = useState(null)

  async function createHealthComplaint(adviceToAdd) {
    setSelectedComplaints((prev) => [...(prev || []), adviceToAdd])
    //fire api to create instruction
  }

  function onCreateComplaint(inputValue, e) {
    const complaintToAdd = {
      apiParam: 'health-complaint',
      value: inputValue,
      label: inputValue,
      __isNew__: true,
    }
    setHealthComplaintToCreate(complaintToAdd)
    if (!!e) {
      setAddComplaintButtonAnchor(e.currentTarget)
    } else {
      setAddComplaintButtonAnchor(true)
    }
  }

  // Capitalise the first letter of each complaint name while preserving the per-row
  // duration/severity fields (mirrors the diagnosis table's onChange).
  function onChangeComplaintsTable(allValues) {
    setSelectedComplaints(
      (allValues || []).map((item) => {
        const label = item?.label || item?.value
        return { ...item, label: label ? getFirstLetterCapitalizedString(label) : label }
      }),
    )
  }

  switch (prescriptionViewSettings?.prescriptionBuilderViewType) {
    case PRESCRIPTION_BUILDER_VIEW_TYPES.tabletView:
      return (
        <>
          <PrescriptionPillViewInputComponent
            additional={{
              page: 1,
              clinicId: clinicId,
              clinicBrandId: clinicBrandId,
              recommendedHealthComplaintIds: recommendedComplaints,
              prescriptionViewSettings,
            }}
            searchPlaceholder="Complaint"
            onChange={(val) => setSelectedComplaints(val)}
            onCreate={onCreateComplaint}
            prescriptionViewSettings={prescriptionViewSettings}
            debounceTimeout={200}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            getOptionsResponse={loadOptionsComplaints}
            value={selectedComplaints}
            itemName={'complaints'}
            title="Complaints"
            contextMenuOpenSide={contextMenuSide}
            showContextFormOnClickNewCondition={(item) => false}
            disableContextMenu={true}
            useFullPageSearch={true}
          />
        </>
      )
    case PRESCRIPTION_BUILDER_VIEW_TYPES.modern:
      return (
        <>
          <PrescriptionTableViewInputComponent
            value={selectedComplaints}
            getOptionValue={(option) => option?.value}
            getOptionLabel={(option) => option?.label}
            getOptionsResponse={loadOptionsComplaints}
            searchPlaceholder="Complaint"
            onChange={(val) => setSelectedComplaints(val)}
            prescriptionViewSettings={prescriptionViewSettings}
            onCreate={onCreateComplaint}
            debounceTimeout={200}
            additional={{
              page: 1,
              clinicId: clinicId,
              clinicBrandId: clinicBrandId,
              recommendedHealthComplaintIds: recommendedComplaints,
              prescriptionViewSettings,
            }}
          />
          <Popover
            anchorEl={addHealthComplaintButtonAnchor}
            open={Boolean(addHealthComplaintButtonAnchor)}
            onClose={() => {
              setAddComplaintButtonAnchor(null)
            }}
          >
            <HealthEntityAddPopover
              healthEntity={healthComplaintToCreate}
              addToHealthEntityArray={createHealthComplaint}
              preferredLanguages={prescriptionViewSettings?.preferredPrescriptionLanguages}
              closePopover={() => setAddComplaintButtonAnchor(null)}
              healthEntityName="Complaint"
              apiParam={'health-complaint'}
            />
          </Popover>
        </>
      )
    default:
      return (
        <div style={{ width: '100%', position: 'relative', zIndex: 1000 }}>
          <ComplaintsTabularInput
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            complaintsList={selectedComplaints}
            onChangeComplaints={onChangeComplaintsTable}
            recommendedComplaintIds={recommendedComplaints}
            prescriptionViewSettings={prescriptionViewSettings}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          />
        </div>
      )
  }
}

export const ComplaintsSelectMenu = ({
  clinicId,
  clinicBrandId,
  selectedComplaints,
  setSelectedComplaints,
  recommendedComplaints = [],
  prescriptionViewSettings,
}) => {
  const [inputValue, setInputValue] = useState('')

  return (
    <div style={{ width: '100%' }}>
      <ComplaintCreatableSelect
        id="complaintsSelection"
        classNamePrefix="complaints_selection"
        closeMenuOnSelect={false}
        placeholder="Complaint"
        isMulti={true}
        isClearable={true}
        isSearchable={true}
        defaultOptions={false}
        loadOptions={loadOptionsComplaints}
        getOptionValue={(option) => option?.value}
        getOptionLabel={(option) => option?.label}
        value={selectedComplaints}
        onChange={(value) => setSelectedComplaints(value)}
        debounceTimeout={200}
        additional={{
          page: 1,
          clinicId: clinicId,
          clinicBrandId: clinicBrandId,
          recommendedHealthComplaintIds: recommendedComplaints,
          prescriptionViewSettings,
        }}
        styles={commonStylesPrescriptionSelect}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        inputValue={inputValue}
        onInputChange={(a, b) => {
          setInputValue((prev) => {
            if (prev === a) {
              return prev
            }
            return a || ''
          })
          handleChangeHealthEntityInputType1(a, b, setSelectedComplaints)
        }}
        onKeyDown={(e) =>
          handleKeyDownAndSupportEdit(
            e,
            inputValue,
            selectedComplaints,
            setSelectedComplaints,
            setInputValue,
          )
        }
      />
    </div>
  )
}
